
import { supabase } from "@/integrations/supabase/client";

/**
 * Fetches all data from backend for export
 */
export const fetchAllDataForExport = async () => {
  try {
    const [
      { data: allProfiles, error: profilesError },
      { data: allBookings, error: bookingsError },
      { data: allParkingSpots, error: parkingSpotsError },
      { data: allCancellationRequests, error: cancellationRequestsError },
      { data: allUserRoles, error: userRolesError },
      { count: usersCount },
      { count: parkingSpotsCount },
      { count: bookingsCount },
      { count: activeBookingsCount },
    ] = await Promise.all([
      // Fetch all profiles
      supabase
        .from('profiles')
        .select('*')
        .order('created_at', { ascending: false }),
      
      // Fetch all bookings
      supabase
        .from('bookings')
        .select(`
          *,
          profiles:user_id (first_name, last_name),
          parking_spot:parking_spots (address, owner_name)
        `)
        .order('created_at', { ascending: false }),
      
      // Fetch all parking spots
      supabase
        .from('parking_spots')
        .select('*')
        .order('created_at', { ascending: false }),
      
      // Fetch all cancellation requests
      supabase
        .from('cancellation_requests')
        .select(`
          *,
          bookings (
            id,
            start_time,
            end_time,
            lot_count,
            parking_spot:parking_spots (
              address,
              owner_name
            )
          ),
          profiles:user_id (
            first_name,
            last_name
          )
        `)
        .order('created_at', { ascending: false }),
      
      // Fetch user roles separately
      supabase
        .from('user_roles')
        .select('*')
        .order('created_at', { ascending: false }),
      
      // Get stats counts
      supabase.from('profiles').select('*', { count: 'exact', head: true }),
      supabase.from('parking_spots').select('*', { count: 'exact', head: true }),
      supabase.from('bookings').select('*', { count: 'exact', head: true }),
      supabase.from('bookings').select('*', { count: 'exact', head: true })
        .eq('status', 'active'),
    ]);

    if (profilesError) throw profilesError;
    if (bookingsError) throw bookingsError;
    if (parkingSpotsError) throw parkingSpotsError;
    if (cancellationRequestsError) throw cancellationRequestsError;
    if (userRolesError) throw userRolesError;

    // Compile all data
    const completeData = {
      stats: {
        totalUsers: usersCount || 0,
        totalParkingSpots: parkingSpotsCount || 0,
        totalBookings: bookingsCount || 0,
        activeBookings: activeBookingsCount || 0,
      },
      users: allProfiles || [],
      userRoles: allUserRoles || [],
      bookings: allBookings || [],
      parkingSpots: allParkingSpots || [],
      cancellationRequests: allCancellationRequests || [],
    };

    return completeData;
  } catch (error) {
    console.error('Error fetching all data for export:', error);
    throw error;
  }
};
